module.exports = __webpack_public_path__ + "media/images/limpia_y_fija-a83ef8bc50756a4bfe3ed5789a853545.jpg";